<template>
    <div class="app">
        <div
            class="headerSwiper-box"
            style="width:928px"
        >
            <el-carousel
                height="450px"
                :interval='3500'
                trigger=click
            >
                <el-carousel-item
                    v-for="(item, index) in swiperData"
                    :key="index"
                >
                    <img :src="item.picUrl" />
                </el-carousel-item>
            </el-carousel>
        </div>
    </div>
</template>

<script>
    export default
    {
        props: [],
        data()
        {
            return {
                swiperData: [
                    { picUrl: require( '../../assets/image/img/NewRegister/banner4.jpg' ) },
                    { picUrl: require( '../../assets/image/img/NewRegister/banner.jpg' ) },
                    { picUrl: require( '../../assets/image/img/NewRegister/banner2.jpg' ) },
                    { picUrl: require( '../../assets/image/img/NewRegister/banner3.jpg' ) },
                ], //轮播图

            }
        },
        created()
        {
            this.getBanner()
        },
        methods:
        {
            getBanner()
            {
                //获取首页轮播图
                let params = {
                    PageNo: 1,
                    PageSize: 10,
                    Params:
                    {
                        type: 1,
                    },
                };
                this.$api.product.getindexBanner( params ).then( ( res ) =>
                {
                    if ( res.data.code == 0 )
                    {
                        console.log( res.data.result.data )
                        if ( res.data.result.data.length > 0 ) this.swiperData = res.data.result.data;
                    }
                    else
                    {
                        this.$message(
                        {
                            message: res.data.message,
                            type: "warning",
                        } );
                    }
                } );
            },
        }
    }
</script>

<style scoped="scoped">
    .headerSwiper-box,
    .headerSwiper-box img {
        width: 100%;
        height: 450px;
    }
</style>
<style>
    .headerSwiper-box .el-carousel__item.is-active {
        /* z-index: 0; */
    }

    .el-carousel__item.is-active {
        z-index: -1;
    }

    .el-carousel__indicators--horizontal {
        bottom: 50px;
    }

    .el-carousel__item {
        z-index: -1;
    }

    .el-carousel__indicators--horizontal {
        bottom: 3.125rem !important;
    }

    .headerSwiper-box .el-carousel__button {
        width: 11px !important;
        height: 11px !important;
        border-radius: 50% !important;
        background-color: #FFFFFF !important;
        /* opacity: 0.2 !important; */

        /* background-color: ; */
    }

    .headerSwiper-box .el-carousel__indicator--horizontal {
        padding: 12px !important;
    }

    .headerSwiper-box .el-carousel__indicator .is-active button {
        opacity: 1 !important;
    }
</style>